import { render, staticRenderFns } from "./GuideBookPaperHead.vue?vue&type=template&id=ba3b51f6"
import script from "./GuideBookPaperHead.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports